export const environment = {
  production: true,
  appConfigOverridePath: null as string | null,
};
